import {
  AccordionButton,
  AccordionButtonProps,
  AccordionIcon,
  Box,
} from '@chakra-ui/react';
import React from 'react';

interface AccordionHeaderProps extends AccordionButtonProps {}

const AccordionHeader: React.FC<AccordionHeaderProps> = ({
  children,
  ...props
}) => {
  return (
    <AccordionButton {...props}>
      <Box flex="1" textAlign="left">
        {children}
      </Box>
      <AccordionIcon />
    </AccordionButton>
  );
};

export default AccordionHeader;
